export interface RequestRecord {
  id: string | null ;
  requestId: number;
  startDate: string;
  endDate: string;
  eventType: EventType;
  caregiverId: string;
  caregiverName:string;
  caregiverType: CaregiverType;
  hoursWorked: number;
  paymentStatus: PaymentStatus;
  paymentLink: string | null;
  discounted: boolean;
  sessionAmount: number;
  notes: string | null;
  createdAt: string;
  updatedAt: string;
}

export enum EventType {
  REPLACEMENT = 'REPLACEMENT',
  USAGE = 'USAGE',
  TRIAL = 'TRIAL',
  ACTIVATION = 'ACTIVATION',
  ABSENCE = 'ABSENCE'
}

export enum CaregiverType {
  BABYSITTER = 'BABYSITTER',
  PETSITTER = 'PETSITTER',
  NURSE = 'NURSE',
  COLF = 'COLF',
  NUTRITIONIST = 'NUTRITIONIST',
  PSYCHOLOGIST = 'PSYCHOLOGIST',
  COACH = 'COACH'
}

export enum PaymentStatus {
  TO_PAY = 'TO_PAY',
  PENDING = 'PENDING',
  PAID = 'PAID',
  CANCELLED = 'CANCELLED',
  REFUNDED = 'REFUNDED',
  // Utilizzo regolarizzato tramite APL (Synergie Italia S.p.A.): il caregiver è
  // assunto da Synergie, che fattura direttamente la famiglia. Nessun incasso
  // F+H su queste ore e nessun link di pagamento: stato di chiusura come
  // CANCELLED / REFUNDED, la partita si liquida fuori dalla piattaforma.
  CONTRATTO_APL = 'CONTRATTO_APL'
}

export interface HoursComputedInterface {
  totalHoursWorked:number;
  totalhourAmount:number;
}
